import { FormControlHelper, FormControlHelperText } from "@gluestack-ui/themed";
import { ISelectHelperText } from "./types";

export const SelectHelperText = ({ text, hasError }: ISelectHelperText) => {
  if (!text || hasError) return null;

  return (
    <FormControlHelper>
      <FormControlHelperText>{text}</FormControlHelperText>
    </FormControlHelper>
  );
};
